export default __webpack_public_path__ + "static/media/ic_tracking_cancelado.85e1c312.svg";